/* eslint-disable import/prefer-default-export */
import lockImage from '../assets/icons/lock.svg';

const fnoActivationOptions = [
  {
    title: "Access via Mobile No.",
    description: "Access your bank account instantly and securely via SETU",
    value: "pennyDrop",
    image: lockImage,
    badge: "Recommended",
  },
  {
    title: "Upload Manually",
    description: "Upload any of your income proof document to enable FnO",
    value: "manual",
  },
]
export { fnoActivationOptions };
